import { createFileRoute } from '@tanstack/react-router';
import { OperationsQuotesPage } from '@/features/operations/quotes-page';

export const Route = createFileRoute('/operations/quotes/')({
  component: OperationsQuotesIndexRoute,
});

function OperationsQuotesIndexRoute() {
  return <OperationsQuotesPage />;
}
